import { ArrowUpRight, Newspaper } from "lucide-react";
import { PRESS } from "../../data/site";
import { Reveal } from "../motion";

export const Press = () => (
  <section data-testid="press-section" className="mx-auto max-w-[1440px] px-5 py-24 sm:px-8 lg:px-12 lg:py-32">
    <Reveal>
      <a href={PRESS.url} target="_blank" rel="noopener noreferrer" data-testid="press-link"
        className="group grid gap-8 rounded-[var(--ngp-radius)] border border-[color:var(--ngp-line)] bg-white p-7 transition-[border-color,box-shadow] duration-500 hover:border-[color:var(--ngp-ink)] hover:shadow-[0_30px_80px_-40px_rgba(0,0,0,.35)] md:grid-cols-12 md:p-12">
        <div className="md:col-span-3">
          <p className="eyebrow flex items-center gap-2 text-[color:var(--ngp-teal-ink)]"><Newspaper size={14} aria-hidden="true" /> Press</p>
          <p className="font-display mt-6 text-3xl font-semibold">{PRESS.outlet}</p>
          <p className="mt-1 text-sm text-[color:var(--ngp-muted)]">Intervista del {PRESS.date}</p>
        </div>
        <div className="md:col-span-7">
          <h2 className="font-display text-3xl font-semibold leading-[1.05] sm:text-4xl lg:text-5xl">“{PRESS.title}”</h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-[color:var(--ngp-muted)]">{PRESS.text}</p>
        </div>
        <div className="flex items-end md:col-span-2 md:justify-end">
          <span className="inline-flex items-center gap-2 text-sm font-semibold">
            Guarda l'intervista
            <span className="grid h-12 w-12 place-items-center rounded-full bg-[color:var(--ngp-ink)] text-white transition-[transform,background-color,color] duration-500 group-hover:rotate-45 group-hover:bg-[color:var(--ngp-teal)] group-hover:text-[color:var(--ngp-ink)]"><ArrowUpRight size={18} aria-hidden="true" /></span>
          </span>
        </div>
      </a>
    </Reveal>
  </section>
);
